/** Where narrations and the narrator samples are served from: the R2 bucket's public domain (nottldr/terraform/cdn.tf), whose keys are `audio/...`. */
export const AUDIO_BASE_URL = "https://cdn.nottldr.com/audio";

/** The URL of one audio file by its name (`<alias>.<id>.<narrator>.m4a`, `<narrator>.sample.m4a`). */
export const audioFileUrl = (name: string): string => `${AUDIO_BASE_URL}/${name}`;
